import React, { memo, useMemo } from 'react';
import { Tag } from 'antd';
import { ReactComponent as OverdueSvg } from '@assets/icons/AWStatuses/overdue.svg';
import { ReactComponent as ApprovedWithFeedbackSvg } from '@assets/icons/AWStatuses/approved-with-feedback.svg';
import { ReactComponent as ApprovedSvg } from '@assets/icons/AWStatuses/approved.svg';
import { ReactComponent as RequireChangesSvg } from '@assets/icons/AWStatuses/require-changes.svg';
import { ReactComponent as PendingSvg } from '@assets/icons/AWStatuses/pending.svg';
import { AWStageMemberDecisionDto } from '@api/Api';

export type MemberDecisionProps = {
  decision?: AWStageMemberDecisionDto['decision'] | 'view' | 'overdue';
};

export default memo(function MemberDecision({
  decision = null
}: MemberDecisionProps) {
  const { color, text, icon } = useMemo(() => {
    if (decision === 'approved')
      return { color: '#58C97A33', text: 'Approved', icon: <ApprovedSvg /> };
    if (decision === 'approved_with_feedback')
      return {
        color: '#496AFC1A',
        text: 'Approved with feedback',
        icon: <ApprovedWithFeedbackSvg />
      };
    if (decision === 'changes_required')
      return {
        color: '#FA8E5233',
        text: 'Changes required',
        icon: <RequireChangesSvg />
      };
    if (decision === 'overdue')
      return { color: '#F7524833', text: 'Overdue', icon: <OverdueSvg /> };
    if (decision === 'view')
      return { color: '#B0DAF8', text: 'In review', icon: <PendingSvg /> };
    return {
      color: '#F5DAE8',
      text: 'Waiting for review',
      icon: <PendingSvg />
    };
  }, [decision]);

  return (
    <span className="status_container">
      <Tag color={color}>
        {icon}
        <div className="status_container--text">{text}</div>
      </Tag>
    </span>
  );
});
